import React from 'react';
import logo from "../assetes/Suite Logo.png";
function Header() {
return (
  <div className="flex justify-center items-center w-full py-5">
  <a href="/">
    <img src={logo} alt="logo" className="w-[100px] cursor-pointer" />
  </a>
</div>

  );
}

export default Header;
